import { createAction, props } from '@ngrx/store';
import { Notification } from './models/notification.interface';

export const NOTIFICATIONS_FEATURE_NAME = 'notifications';

export const addNotification = createAction(
  `[${NOTIFICATIONS_FEATURE_NAME}] Add notification`,
  props<{ notification: Notification }>(),
);

export const removeNotification = createAction(
  `[${NOTIFICATIONS_FEATURE_NAME}] Remove notification`,
  props<{ createdAt: Date; }>(),
);

export const removeNotificationByErrorObject = createAction(
  `[${NOTIFICATIONS_FEATURE_NAME}] Remove notification by Timer`,
  props<{ errorObject; }>(),
)

export const removeAllNotifications = createAction(
  `[${NOTIFICATIONS_FEATURE_NAME}] Remove all notifications`,
);

export const hideNotification = createAction(
  `[${NOTIFICATIONS_FEATURE_NAME}] Hide notification`,
  props<{ createdAt: Date; }>(),
);

export const toggleExpanded = createAction(
  `[${NOTIFICATIONS_FEATURE_NAME}] Toggle expanded notification`,
  props<{ id: number }>(),
);
